class MenuController {
  /* @ngInject */
  constructor($http, Session, $rootScope) {
    this.$http = $http;
    this.Session = Session;
    this.$rootScope = $rootScope;
  }

  $onInit() {
    this.user = this.Session.read('userinfo');
    this.isVendor = this.user.client.type === 'VENDOR';
    if (this.user) {
      this.fin_mgr_id = true;
    }
  }
}

export default MenuController;



// WEBPACK FOOTER //
// ./client/components/aside-menu/aside-menu.controller.js